<template>
  <div class="timeline-filter">
    <a-dropdown :trigger="['click']" v-model="dropdownVisible">
      <button
        type="button"
        class="timeline-filter__toggle"
        :class="{ 'timeline-filter__toggle--active': value }"
      >
        <a-icon type="filter" class="timeline-filter__icon" />
        <span class="timeline-filter__tag" v-if="displayTag">
          {{ displayTag }}
        </span>
        <template v-else>筛选&hellip;</template>
      </button>
      <a-menu
        slot="overlay"
        selectable
        @select="handleSelect"
        :selectedKeys="videoSeriesTagMode ? [] : [value]"
        class="timeline-filter-menu"
      >
        <template v-if="videoSeriesTagsVisible">
          <a-menu-item-group class="timeline-filter-menu__search">
            <li
              class="ant-dropdown-menu-item"
              :class="{
                'ant-dropdown-menu-item-selected': videoSeriesTagMode
              }"
              @click="toggleVideoSeriesTagMode"
              slot="title"
            >
              系列视频标签
            </li>
          </a-menu-item-group>
          <a-menu-divider />
        </template>
        <a-menu-item v-for="item in filterTypes" :key="item">
          {{ filterNames[item] }}
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item v-for="item in filterStates" :key="item">
          {{ filterNames[item] }}
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item-group class="timeline-filter-menu__search">
          <template slot="title">
            <input
              class="timeline-filter-menu__input"
              placeholder="按名称搜索"
              v-model="inputValue"
              @select.stop
            />
            <a-icon type="search" class="timeline-filter-menu__icon" />
          </template>
        </a-menu-item-group>
      </a-menu>
    </a-dropdown>
    <a-button
      class="timeline-filter__clear"
      type="link"
      v-if="displayTag"
      @click="clear"
    >
      <a-icon :component="ClearIcon" />
    </a-button>
  </div>
</template>
<script>
const ClearIcon = {
  render() {
    return this.$createElement('svg',
      { attrs: { viewBox: '0 0 16 16' } },
      [
        this.$createElement('path', {
          attrs: {
            d: 'M8,1 C4.134375,1 1,4.134375 1,8 C1,11.865625 4.134375,15 8,15 C11.865625,15 15,11.865625 15,8 C15,4.134375 11.865625,1 8,1 Z M10.584375,10.659375 L9.553125,10.6546875 L8,8.803125 L6.4484375,10.653125 L5.415625,10.6578125 C5.346875,10.6578125 5.290625,10.603125 5.290625,10.5328125 C5.290625,10.503125 5.3015625,10.475 5.3203125,10.4515625 L7.353125,8.0296875 L5.3203125,5.609375 C5.3015625,5.5859375 5.290625,5.5578125 5.290625,5.528125 C5.290625,5.459375 5.346875,5.403125 5.415625,5.403125 L6.4484375,5.4078125 L8,7.259375 L9.5515625,5.409375 L10.5828125,5.4046875 C10.6515625,5.4046875 10.7078125,5.459375 10.7078125,5.5296875 C10.7078125,5.559375 10.696875,5.5875 10.678125,5.6109375 L8.6484375,8.03125 L10.6796875,10.453125 C10.6984375,10.4765625 10.709375,10.5046875 10.709375,10.534375 C10.709375,10.603125 10.653125,10.659375 10.584375,10.659375Z'
          }
        })
      ]);
  }
};

export default {
  data() {
    return {
      ClearIcon,
      filterTypes: ['text', 'image', 'video', 'shape', 'lottie', 'sticker', 'group', 'container', 'textContainer', 'wordArt'],
      filterStates: ['locked', 'unlocked', 'hidden', 'visible'],
      filterNames: {
        text: '文本',
        image: '图片',
        video: '视频',
        shape: '形状',
        lottie: '动画/特效',
        sticker: '贴纸',
        container: '容器',
        textContainer: '文本容器',
        group: '组合',
        wordArt: '艺术字',
        locked: '已锁定',
        unlocked: '未锁定',
        hidden: '已隐藏',
        visible: '可见'
      },
      dropdownVisible: false
    };
  },
  props: ['value'],
  computed: {
    inputValue: {
      get() {
        if (/^n:/.test(this.value)) {
          return this.value.slice(2);
        }
        return '';
      },
      set(v) {
        this.$emit('change', v ? 'n:' + v : '');
      }
    },
    displayTag() {
      if (this.videoSeriesTagMode) {
        return '系列视频标签';
      }
      if (!this.value) {
        return '';
      }
      if (/^n:/.test(this.value)) {
        return '名称: ' + this.value.slice(2);
      }
      return this.filterNames[this.value];
    },
    videoSeriesTagsVisible() {
      const { userBasics } = this.$store.state;
      return userBasics && userBasics.is_open_template;
    },
    videoSeriesTagMode() {
      return this.$store.state.videoSeriesTagMode;
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    handleSelect({ key }) {
      this.$emit('change', key);
      this.dropdownVisible = false;
    },
    clear() {
      this.$emit('change', '');
    },
    toggleVideoSeriesTagMode() {
      this.$store.dispatch('toggleVideoSeriesTagMode');
      this.dropdownVisible = false;
    }
  }
}
</script>
<style>
.timeline-filter {
  height: 24px;
  position: relative;
  font-size: 12px;
  margin-left: 12px;
  padding: 0 24px;
  display: flex;
}

.timeline-filter:before {
  content: "";
  position: absolute;
  left: 0;
  top: 5px;
  bottom: 5px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.timeline-filter__toggle {
  display: flex;
  color: rgba(0, 0, 0, 0.35);
  align-items: center;
  transition: 0.3s;
  padding: 0 8px 0 0;
  margin: -6px 0;
  cursor: pointer;
  border: 0;
  outline: 0;
  background: transparent;
}

.timeline-filter__toggle--active {
  color: #007eff;
}

.timeline-filter__toggle:hover,
.timeline-filter__toggle:focus {
  color: rgba(0, 0, 0, 0.75);
}

.timeline-filter__tag {
  background: rgba(0, 126, 255, 0.75);
  color: #fff;
  padding: 2px 6px;
  border-radius: 2px;
}

.timeline-filter__toggle:hover .timeline-filter__tag,
.timeline-filter__toggle:focus .timeline-filter__tag {
  background-color: #007eff;
}

.timeline-filter__toggle:disabled {
  color: rgba(0, 0, 0, 0.75);
  opacity: 0.2;
}

.timeline-filter__icon {
  margin-right: 6px;
  font-size: 14px;
}

.timeline-filter__clear {
  font-size: 16px;
  height: 24px;
  padding: 0 4px;
  color: #d9d9d9;
  position: absolute;
  right: 0;
  top: 0;
}

.timeline-filter__clear:hover,
.timeline-filter__clear:focus,
.timeline-filter__clear:active {
  color: #e36;
}

.timeline-filter-menu {
  max-height: 100vh;
  min-width: 140px;
  overflow: auto;
  background: #fff;
  margin-bottom: -7px;
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.06);
}

.timeline-filter-menu .ant-dropdown-menu-item,
.timeline-filter-menu .ant-dropdown-menu-item > a {
  padding-left: 16px;
  padding-right: 16px;
}

.timeline-filter-menu .ant-dropdown-menu-item > a {
  margin-left: -16px;
  margin-right: -16px;
}

.timeline-filter-menu .ant-dropdown-menu-item-active,
.timeline-filter-menu .ant-dropdown-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.08);
}

.timeline-filter-menu__search .ant-dropdown-menu-item-group-title {
  padding: 0;
  position: relative;
  height: 30px;
}

.timeline-filter-menu__input {
  padding: 4px 16px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 0;
  border: 0;
  outline: 0;
  color: rgba(0, 0, 0, 0.75);
  transition: 0.3s;
}

.timeline-filter-menu__input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.35);
}

.timeline-filter-menu__input:hover,
.timeline-filter-menu__input:focus {
  background-color: rgba(0, 0, 0, 0.06);
}

.timeline-filter-menu__icon {
  position: absolute;
  right: 10px;
  top: 9px;
  color: rgba(0, 0, 0, 0.2);
}
</style>